<template>
  <div class="air_conditioner_form">
    <div class="tit">
      <span>空调安维申请</span>
    </div>
    <div class="body_content">
      <el-form :model="params" ref="myform" label-position="top">
        <h2>基本情况</h2>
        <el-row>
          <el-col :span="12">
            <el-form-item label-width="170px" prop="company" label="申请单位名称：">
              <el-input
                class="input-width"
                maxlength="30"
                show-word-limit
                v-model="params.company"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="所在楼栋:"
              prop="building"
              :rules="[{ required: true, message: '请选择所在楼栋', trigger: 'blur' }]"
            >
              <el-select
                v-model="params.building"
                filterable
                placeholder="请选择所在楼栋"
                class="input-width"
              >
                <el-option
                  v-for="item in buildings"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          
          <el-col :span="12">
            <el-form-item
              prop="unit_code"
              label="合同房号："
              :rules="[{ required: true, message: '请填写租赁合同上的房号', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.unit_code" placeholder="填写租赁合同上的房号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="contact"
              label="经办人："
              :rules="[{ required: true, message: '请填写经办人的真实姓名', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.contact" placeholder="请填写经办人的真实姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          
          <el-col :span="12">
            <el-form-item
              prop="contact_phone"
              label="手机号："
              :rules="[{ required: true, message: '请填写经办人的真实手机号', trigger: 'blur' }]"
            >
              <el-input
                class="input-width"
                v-model="params.contact_phone"
                placeholder="请填写经办人的真实手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item
              prop="vrv_project_type"
              label="工程类型："
              :rules="[{ required: true, message: '请选择工程类型', trigger: 'blur' }]"
            >
              <el-radio-group v-model="params.vrv_project_type">
                <el-radio :label="item.val" v-for="item in proType">{{item.name}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="意向预约时间:"
              prop="plan_date"
              :rules="[{ required: true, message: '请选择意向预约时间', trigger: 'blur' }]"
            >
              <el-date-picker
                class="input-width"
                v-model="params.plan_date"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="选择意向预约时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="计划实施时间:"
              prop="vrv_install_date"
              :rules="[{ required: true, message: '请选择计划实施时间', trigger: 'blur' }]"
            >
              <el-date-picker
                class="input-width"
                v-model="params.vrv_install_date"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="请选择计划实施时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item
              prop="vrv_brand"
              label="空调品牌："
              :rules="[{ required: true, message: '请填写空调品牌', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.vrv_brand" placeholder="填写空调品牌"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="vrv_model"
              label="空调型号："
              :rules="[{ required: true, message: '请填写空调型号', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.vrv_model" placeholder="填写空调型号"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="空调类型:"
              prop="vrv_type"
              :rules="[{ required: true, message: '请选择空调类型', trigger: 'blur' }]"
            >
              <el-select
                v-model="params.vrv_type"
                filterable
                placeholder="请选择空调类型"
                class="input-width"
              >
                <el-option
                  v-for="item in type"
                  :key="item.val"
                  :label="item.name"
                  :value="item.val"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="vrv_num"
              label="安装维修数量："
              :rules="[{ required: true, message: '请填写安装维修数量', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.vrv_num" placeholder="请填写安装维修数量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="12">
            <el-form-item
              prop="vrv_horse"
              label="产品匹数："
              :rules="[{ required: true, message: '请填写空调匹数，如1匹', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.vrv_horse" placeholder="请填写空调匹数，如1匹"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="vrv_power"
              label="最大功率："
              :rules="[{ required: true, message: '请填写空调最大功率', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.vrv_power" placeholder="填写空调最大功率"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label-width="170px" label>
          <el-button type="primary" @click="submit(true)">提交审核</el-button>
          <el-button @click="go('enterprise_air_conditioner_table_list');">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import changeMobile from "@/components/changeMobile/change_mobile";
import uploadImg from "@/components/file_upload/uploadImg.vue";
export default {
  components: {
    changeMobile,
    uploadImg
  },
  data() {
    return {
      params: {
        vrv_project_type: "",
        vrv_type:''
      },
      buildings: [], //楼盘
      loading: false,
      type: [
      {name:'挂式空调',val:10},
      {name:'立式空调',val:20},
      {name:'天花机空调',val:30},
    ], //空调类型
    proType:[
      { name:'空调安装',val:10},
      { name:'空调维修',val:20},
    ],
      apiParams2: {
        params: {
          //文件上传所需要的参数
          catalog: "CatalogUserHead",
          loginKey: ""
        },
        imgPath: "release_images_paths", //文件路径字段
        fileId: "release_images" //文件id字段
      }
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    parkInfo() {
      return this.$store.state.parkInfo;
    },
    company() {
      return this.$store.state.company;
    }
  },
  created() {
    if (this.parkInfo) {
      this.initPage();
    } else {
      this.needInfo("parkInfo", "initPage");
    }
  },
  methods: {
    /* 监测信息 */
    needInfo(name, fn) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[fn] && this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    initParams() {
      this.params = Object.assign({}, this.params, {
        company: this.company
      });
    },
    initPage() {
      this.getBuildings(); //条件查询楼盘（前台）
      this.getList(); //编辑数据
    },
    //条件查询楼盘（前台）
    getBuildings() {
      let params = {
        incubator: this.parkInfo.id,
        pageSize: 999
      };
      this.api.getBuildings(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.buildings = res.obj.list;
      });
    },
    /** 列表*/
    getList() {
      if (!this.$route.query.id) {
        if (this.company) {
          this.initParams();
        } else {
          this.needInfo("parkInfo", "initParams");
        }
        return;
      }
      let params = Object.assign({}, this.layerpageinfo, this.form, {
        id: this.$route.query.id,
        incubator: this.parkInfo.id
      });
      this.api.getApply(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let obj = res.obj.list[0] || null;
        if (obj) {
          this.params = Object.assign({}, this.params, obj);
        }
      });
    },
    /** 提交表单验证*/
    submit(type) {
      this.$refs["myform"].validate(valid => {
        if (valid) {
          this.save(type);
        } else {
          this.$message.info("请检测必填项!");
          return false;
        }
      });
    },
    /** 保存表单内容*/
    save(type) {
      let params = Object.assign({}, this.params, {
        incubator: this.parkInfo.id,
        id: this.$route.query.id || "",
        contact_phone:this.info.mobile,
        types: "10"
      });
      this.api.submitApply(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.$message.success("操作成功");
        this.$router.push({
          name: "enterprise_air_conditioner_table_list"
        });
      });
    },
    go(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.air_conditioner_form {
  h2 {
    font-weight: 700;
    font-size: 20px;
    text-align: left;
    line-height: 40px;
  }
  .my_row {
    text-align: center;
    line-height: 30px;
  }
  p {
    padding: 20px;
    border: 1px solid #999;
    font-size: 14px;
    line-height: 20px;
    background: #f0f0f0;
  }
}
</style>